export default {"src":"https://web.cdn.greenlight.com/2.1294.3/_next/static/media/shield.d0616ba7.svg","height":38,"width":32,"blurWidth":0,"blurHeight":0};